export function base64ToArrayBuffer(data) {
  var binaryString = window.atob(data);
  var binaryLen = binaryString.length;
  var bytes = new Uint8Array(binaryLen);
  for (var i = 0; i < binaryLen; i++) {
    var ascii = binaryString.charCodeAt(i);
    bytes[i] = ascii;
  }
  return bytes;
}

const MIME_TYPES = {
  pdf: "application/pdf",
  doc: "application/msword",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  txt: "text/plain",
  rtf: "application/rtf",
  png: "image/png",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
};

export function getFileExtension(url) {
  const path = (url || "").split("?")[0];
  const lastSegment = path.substring(path.lastIndexOf("/") + 1);
  const dotIndex = lastSegment.lastIndexOf(".");
  return dotIndex > -1 ? lastSegment.substring(dotIndex + 1).toLowerCase() : "pdf";
}

export function downloadFileFromBase64Data(base64, fileName, extension = "pdf") {
  const fileNameDownload = fileName.toLowerCase().endsWith(`.${extension}`) ? fileName : `${fileName}.${extension}`;
  var arrBuffer = base64ToArrayBuffer(base64);
  var newBlob = new Blob([arrBuffer], { type: MIME_TYPES[extension] || "application/octet-stream" });
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(newBlob);
    return;
  }
  var data = window.URL.createObjectURL(newBlob);
  var link = document.createElement("a");
  document.body.appendChild(link); //required in FF, optional for Chrome
  link.href = data;
  link.target = "_self";
  link.download = fileNameDownload;
  link.click();
  link.remove();
  // Revoking straight after click cancels the download in iOS Safari and Firefox.
  setTimeout(() => window.URL.revokeObjectURL(data), 60 * 1000);
}

export function downloadPdfFromBase64Data(base64, fileName) {
  downloadFileFromBase64Data(base64, fileName, "pdf");
}

export function downloadZipFromBase64Data(base64, fileName) {
  const fileNameDownload = `${fileName}.zip`;
  var arrBuffer = base64ToArrayBuffer(base64);
  var newBlob = new Blob([arrBuffer], { type: "application/zip" });
  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    window.navigator.msSaveOrOpenBlob(newBlob);
    return;
  }
  var data = window.URL.createObjectURL(newBlob);
  var link = document.createElement("a");
  document.body.appendChild(link); //required in FF, optional for Chrome
  link.href = data;
  link.download = fileNameDownload;
  link.click();
  window.URL.revokeObjectURL(data);
  link.remove();
}

const IR330_DOC_NAME = "IR330 electronic signature";
const KS2_DOC_NAME = "KS2 - Kiwisaver Deduction Form";
const KS10_DOC_NAME = "KS10 - Kiwisaver Opt out Request";
const DRIVERCONSENT_DOC_NAME = "Driver Information Access Consent Form";
const JOINAUNION_DOC_NAME = "Union Choice Intention";

export function isInteractivePdfDocument(documentName) {
  return documentName===IR330_DOC_NAME || documentName===KS2_DOC_NAME || documentName===KS10_DOC_NAME ||
  documentName === DRIVERCONSENT_DOC_NAME || documentName === JOINAUNION_DOC_NAME;
}

export function isIR330Document(documentName) {
  return documentName === IR330_DOC_NAME
}

export function isKS2Document(documentName) {
  return documentName === KS2_DOC_NAME
}

export function isKS10Document(documentName) {
  return documentName === KS10_DOC_NAME
}

export function isDriverConsentDocument(documentName) {
  return documentName === DRIVERCONSENT_DOC_NAME
}

export function isJoinAUnionDocument(documentName) {
  return documentName === JOINAUNION_DOC_NAME
}